import {
  jb_bypass_block_css_default
} from "./chunk.5PAKPN5L.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.WKUNRGJV.js";
import {
  n
} from "./chunk.LWNTGWZJ.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-bypass-block/jb-bypass-block.ts
var JbBypassBlock = class extends r {
  _handleKeyDown(evt) {
    if (evt.code === "Space") {
      evt.preventDefault();
      evt.target.click();
    }
  }
  _handleMouseEventBypassBlock(evt) {
    const itemName = evt.target.dataset.name;
    this.dispatchEvent(
      new CustomEvent("jb-bypass-block:navigate", { detail: { name: itemName }, bubbles: true, composed: true })
    );
  }
  render() {
    return ke`<div class="bypass-block">
      ${this.items.map(
      (item) => ke`${item.href ? ke`<a
                aria-label="${item.label}"
                data-name="${item.name}"
                href="${item.href}"
                role="button"
                @click=${this._handleMouseEventBypassBlock}
                @keydown=${this._handleKeyDown}
              >
                ${item.label}
              </a>` : ke`<button
                aria-label="${item.label}"
                data-name="${item.name}"
                @click=${this._handleMouseEventBypassBlock}
              >
                ${item.label}
              </button>`}`
    )}
    </div>`;
  }
};
JbBypassBlock.styles = jb_bypass_block_css_default;
__decorateClass([
  n({ type: Array })
], JbBypassBlock.prototype, "items", 2);
JbBypassBlock = __decorateClass([
  customElement("jb-bypass-block")
], JbBypassBlock);

export {
  JbBypassBlock
};
